import { CoreModule } from './@core/core.module';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injector } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MessaggiHomeService } from './admin/messaggi/messaggi-home/messaggi_home.service';
import { InfoPaginaService } from './admin/messaggi/info-pagina/info-pagina.service';
import { AlertQuesitoService } from './admin/messaggi/alert-quesito/alert-quesito.service';
import { AlertService } from './admin/messaggi/alert/alert.service';
import { FaqSottocategorieService } from './admin/info-faq/faq_sottocategorie/faq_sottocategorie.service';
import { EsameCategoriaService } from './admin/gestione_esami/esami_categorie/esami-categorie.service';
import { CittadinanzeService } from './admin/anagrafica/cittadinanze/cittadinanze.service';
import { FaqsService } from './admin/info-faq/faqs/faqs.service';
import { StrutturaService } from './admin/strutture-sanitarie/strutture/struttura.service';

import { NbEmailPassOAuthProvider } from './hm-auth/netfarmOAuthService/email/email-pass-oauth.provider';

import { NbEvaIconsModule } from '@nebular/eva-icons';
import { SpagentModule } from './spagent/spagent.module';
import { ProfessioneService } from './admin/anagrafica/professioni/professioni.service';
import { TitoloStudioService } from './admin/anagrafica/titoli_studio/titoli_studio.service';
import { FaqCategorieService } from './admin/info-faq/faq_categorie/faq_categorie.service';
import { FaqMacrotemiService } from './admin/info-faq/faq_macrotemi/faq_macrotemi.service';
import { QuestionarioService } from './admin/messaggi/questionari/questionari.service';
import { FaqOperatoriService } from './admin/faq-operatori/faq-operatori/faq-operatori.service'; import { TokenInterceptor } from './hm-auth/netfarmOAuthService/token.interceptor';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { NbSamlPassOAuthProvider } from './hm-auth/netfarmOAuthService/saml/saml-pass-oauth.provider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminAuthGuard } from './admin/admin-auth-guard';
import { UsersAuthGuard } from './users/users-auth-guard';
import { NbSidebarModule, NbMenuModule, NbDatepickerModule, NbDialogModule, NbWindowModule, NbToastrModule } from '@nebular/theme';
import { RouterModule } from '@angular/router';
import { HmAuthModule } from './hm-auth/hm-auth.module';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { SchemaFormModule } from 'ngx-schema-form';
import { environment } from '@src/environments/environment';
// import { AgmCoreModule } from '@agm/core';
import { MODULES_NB } from './@core/utils/nb_modules';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { NtfFormlyModule } from './ntf-formly/ntf-formly.module';
import { GoogleMapsModule } from '@angular/google-maps';


import { registerLocaleData } from '@angular/common';

import localeIt from '@angular/common/locales/it';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeDe from '@angular/common/locales/de';
import { NgxEchartsModule } from 'ngx-echarts';

registerLocaleData(localeIt);
registerLocaleData(localeFr);
registerLocaleData(localeEs);
registerLocaleData(localeDe);


registerLocaleData(localeFr);

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        NgbModule,
        // NbCardModule,
        // NbCheckboxModule,
        // NbAlertModule,
        // NbActionsModule,
        // NbListModule,
        // NbButtonModule,
        // NbCalendarModule,
        // NbCalendarKitModule,
        // NbCalendarRangeModule,
        // NbIconModule,
        // NbProgressBarModule,
        // NbSelectModule,
        // NbSpinnerModule,
        // NbTabsetModule,
        // NbRouteTabsetModule,
        // NbThemeModule,
        // NbUserModule,
        // NbContextMenuModule,
        // NbPopoverModule,
        // NbInputModule,
        // NbAccordionModule,
        // NbRadioModule,

        ...MODULES_NB,

        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbDialogModule.forRoot(),
        NbWindowModule.forRoot(),
        NbToastrModule.forRoot(),
        NbEvaIconsModule,
        //NbChatModule.forRoot({messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',}),
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ThemeModule.forRoot(),
        SchemaFormModule.forRoot(),

        // AgmCoreModule.forRoot({ apiKey: environment.google_maps_api_key, }),
        GoogleMapsModule,

        //EmbedVideo.forRoot(),
        CoreModule.forRoot(),

        HmAuthModule,
        SharedModule,
        NtfFormlyModule,
        AppRoutingModule,

        FormlyModule.forRoot({ extras: { lazyRender: true } }),
        FormlyBootstrapModule,
        NgxDatatableModule,
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts'),
        }),
    ],
    bootstrap: [AppComponent],


    providers: [
        SpagentModule,
        StrutturaService,
        ProfessioneService,
        FaqsService,
        CittadinanzeService,
        EsameCategoriaService,
        TitoloStudioService,
        FaqSottocategorieService,
        FaqCategorieService,
        FaqMacrotemiService,
        AlertService,
        AlertQuesitoService,
        InfoPaginaService,
        MessaggiHomeService,
        QuestionarioService,
        FaqOperatoriService,
        AdminAuthGuard,
        RouterModule,

        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        UsersAuthGuard,

        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: NbEmailPassOAuthProvider, deps: [Injector], useClass: NbEmailPassOAuthProvider },

        { provide: NbSamlPassOAuthProvider, deps: [Injector], useClass: NbSamlPassOAuthProvider },
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },

    ],
})
export class AppModule {
}
